import { render, staticRenderFns } from "./attributeSpeech.vue?vue&type=template&id=733ce7ae&scoped=true&"
import script from "./attributeSpeech.vue?vue&type=script&lang=js&"
export * from "./attributeSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ce7ae",
  null
  
)

export default component.exports